// Leilão Reverso de Frete — lado do embarcador (épico PO1-3076; H3 PO1-3084,
// H4 PO1-3086, H5 PO1-3087). Todas as chamadas levam `embarcadorId` do seletor
// do cabeçalho (useCompanies): o backend confere o escopo em cada rota.
import api from "./api";

export async function listarLeiloes(embarcadorId, { estado, limite } = {}) {
  const { data } = await api.get("/gobid/leiloes", { params: { embarcadorId, estado: estado || undefined, limite } });
  return data;
}

// baseNumEmbarque → { leilaoId, numero, estado, fechaEm } das ofertas vivas (selo "Em leilão").
export async function leiloesAtivos(embarcadorId) {
  const { data } = await api.get("/gobid/leiloes/ativos", { params: { embarcadorId } });
  return data;
}

// Cotações do embarcador (mesma rota de Minhas Cotações), para escolher qual
// leiloar a partir da tela de Leilões.
export async function listarCotacoesEmbarcador(embarcadorId) {
  const { data } = await api.get(`/embarcadores/embarques/${embarcadorId}`);
  return Array.isArray(data) ? data : [];
}

// Cotação completa (com as propostas da simulação em `cotacoes`), para mostrar
// a referência do preço-alvo no leilão direto.
export async function obterCotacao(embarqueId) {
  const { data } = await api.get(`/embarcadores/embarques/by-id/${embarqueId}`);
  return data;
}

export async function candidatosLeilao(embarcadorId, embarqueId) {
  const { data } = await api.get("/gobid/leiloes/candidatos", { params: { embarcadorId, embarqueId } });
  return data;
}

export async function obterLeilao(embarcadorId, id) {
  const { data } = await api.get(`/gobid/leiloes/${id}`, { params: { embarcadorId } });
  return data;
}

// { embarqueId, precoAlvo, duracaoMin, dataColeta, convidados: [{ idTransportadora, email? }], userNome? }
export async function criarLeilao(embarcadorId, dados) {
  const { data } = await api.post("/gobid/leiloes", { ...dados, embarcadorId });
  return data;
}

export async function encerrarLeilao(embarcadorId, id) {
  const { data } = await api.post(`/gobid/leiloes/${id}/encerrar`, { embarcadorId });
  return data;
}

export async function cancelarLeilao(embarcadorId, id, { userNome } = {}) {
  const { data } = await api.post(`/gobid/leiloes/${id}/cancelar`, { embarcadorId, userNome });
  return data;
}

export async function reenviarConvite(embarcadorId, id, convidadoId) {
  const { data } = await api.post(`/gobid/leiloes/${id}/convidados/${convidadoId}/reenviar`, { embarcadorId });
  return data;
}

export async function adjudicarLeilao(embarcadorId, id, { lanceId, justificativa, userNome } = {}) {
  const { data } = await api.post(`/gobid/leiloes/${id}/adjudicar`, { embarcadorId, lanceId, justificativa, userNome });
  return data;
}

export async function reabrirLeilao(embarcadorId, id, { precoAlvo, duracaoMin, dataColeta, userNome } = {}) {
  const { data } = await api.post(`/gobid/leiloes/${id}/reabrir`, { embarcadorId, precoAlvo, duracaoMin, dataColeta, userNome });
  return data;
}

// PO1-3528 (épico PO1-3527): taxa de resposta dos convidados por origem
// (carteira x fora) nos últimos `dias` (7 a 365; padrão 90).
// { dias, carteira: { convidados, responderam, lances, recusas, taxa }, fora: {...} }
export async function indicadoresResposta(embarcadorId, { dias } = {}) {
  const { data } = await api.get("/gobid/leiloes/indicadores/resposta", { params: { embarcadorId, dias } });
  return data;
}

// "Convidar para a carteira" (P7): entrada pela carteira, PO1-2299.
export async function convidarParaCarteira(embarcadorId, { cnpj, nome }) {
  const { data } = await api.post("/transportadoras/minhas", { embarcadorId, cnpj, apelido: nome });
  return data;
}
